import { Descope, useSession } from '@descope/react-sdk';
import { Navigate, createFileRoute, useNavigate } from '@tanstack/react-router';

function SignInPage() {
  const { isAuthenticated, isSessionLoading } = useSession();
  const navigate = useNavigate();

  // Don't render the flow (or redirect) until Descope has resolved the session,
  // otherwise we race the async refresh and flicker the sign-in form for an
  // already-authenticated user.
  if (isSessionLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <Descope
        flowId="sign-up-or-in"
        theme="dark"
        onSuccess={() => navigate({ to: '/' })}
      />
    </div>
  );
}

export const Route = createFileRoute('/sign-in')({
  component: SignInPage,
});
